import React from 'react';
import { Col, Flex, Form, Select, Typography } from 'antd';

const { Option } = Select;
const { Text } = Typography;

interface DataItem {
  uid: string; // Add the uid field
  title: string;
  description: string;
}

interface CustomSelectProps {
  data: DataItem[];
  title?: string;
  formItemName: string;
  placeholder?: string;
  titleStyle?: string;
  parentStyle?: string;
  isLoading?: boolean;
  onSelect?: (uid: string) => void;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  data,
  title,
  titleStyle,
  placeholder,
  parentStyle,
  isLoading,
  onSelect,
  formItemName,
}) => {
  const handleChange = (value: string) => {
    const selectedItem = data.find((item) => item.title === value);
    if (selectedItem && onSelect) {
      onSelect(selectedItem?.uid);
    }
  };

  return (
    <Flex vertical className={`${parentStyle}`}>
      <Text className={`${titleStyle}`}>{title}</Text>
      <Form.Item name={formItemName} className='mb-0'>
        <Select
          loading={isLoading}
          onChange={handleChange}
          variant='borderless'
          placeholder={placeholder}
          optionLabelProp='label'
          className='border px-[5px] border-solid w-full h-[40px] custom-select-placeholder custom-select-item border-sd-input bg-sd-input-bg rounded-md'
        >
          {data.map((item, index) => (
            <Option key={index} value={item.uid} label={item.title}>
              <Col>
                <Text className='font-semibold text-sm text-sd-foreground'>
                  {item.title}
                </Text>
                <br />
                <Text className='font-normal text-xs text-sd-muted-foreground'>
                  {item.description}
                </Text>
              </Col>
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Flex>
  );
};

export default CustomSelect;
